import { useParams, useLocation, Link } from 'react-router-dom'
import { ArrowLeft, MapPin } from 'lucide-react'
import BSDCard from './BSDCard'
import DistrictMap from './DistrictMap'
import { RSD_LIST, CSS_LIST, CDD_LIST, type StrutturaDisabilita } from '../data/struttureDisabilita'
import { DisabilitaDetailContent } from './StrutturaDetailDialog'
import type { SezioneCard } from './SectionBadge'

const LISTS: Record<string, { list: StrutturaDisabilita[]; tipo: 'RSD' | 'CSS' | 'CDD'; sezione: SezioneCard }> = {
  rsd: { list: RSD_LIST, tipo: 'RSD', sezione: 'Residenze Sanitarie Disabili' },
  css: { list: CSS_LIST, tipo: 'CSS', sezione: 'Comunità Socio Sanitarie' },
  cdd: { list: CDD_LIST, tipo: 'CDD', sezione: 'Centri Diurni Disabili' },
}

export default function DisabilitaDetailPage({ prefix }: { prefix: 'rsd' | 'css' | 'cdd' }) {
  const { slug } = useParams<{ slug: string }>()
  const location = useLocation()
  const state = location.state as { from?: string } | null
  const backTo = state?.from || `/${prefix}`
  const { list, tipo, sezione } = LISTS[prefix]

  const struttura = slug ? list.find(s => s.id === slug) : undefined

  if (!struttura) {
    return (
      <div className="cdc-detail-page">
        <div className="cdc-detail-container">
          <Link to={backTo} className="cdc-detail-back"><ArrowLeft size={16} /> Torna</Link>
          <h1>Struttura non trovata</h1>
        </div>
      </div>
    )
  }

  return (
    <div className="cdc-detail-page">
      <div className="cdc-detail-container">
        <Link to={backTo} className="cdc-detail-back"><ArrowLeft size={16} /> Torna</Link>

        <BSDCard kind="custom" className="cdc-detail-info-card" sezione={sezione} style={{ padding: 20 }}>
          <DisabilitaDetailContent struttura={struttura} tipo={tipo} />
        </BSDCard>

        <BSDCard kind="custom" className="cdc-detail-map-card" sezione={sezione}>
          <h2 className="cdc-detail-section-title"><MapPin size={16} /> Mappa del distretto</h2>
          <DistrictMap
            onSelectDistrict={() => {}}
            onClearSelection={() => {}}
            selectedDistrictId={struttura.ambitoId}
            allowDistrictSelection={false}
            showLegend={false}
            showInstructionText={false}
          />
        </BSDCard>
      </div>
    </div>
  )
}
